import { createSlice } from '@reduxjs/toolkit';

const initialData = {
  selectedOne: null,
  isAllSelected: false,

  isLocationSelected: [],
  isSpecificLocationSelected: [],
  isMachineSelected: [],

  selectedLocations: [],
  selectedSpecificLocations: [],
  selectedMachines: [],
  displaySelectBox: false,

  isApplied: false,
  inputTemp: 0,
  isF: false,
  scheduleList: [
    {
      start: { date: null, time: null },
      end: { date: null, time: null },
      inputTemp: null,
      isF: null,
    },
  ],
};

const initialState = {
  instantHeat: initialData,
  snowSensor: initialData,
  optionalConstant: initialData,
  heatingSchedule: initialData,
  windFactor: initialData,
  ats: initialData,
  shutOff: initialData,
  fanOnly: initialData,
};

const masterControlSelectBySwitchSlice = createSlice({
  name: 'masterControlSelectBySwitch',
  initialState,
  reducers: {

    handleResetSelectedOne: (state) => {
      state.instantHeat.selectedOne = null;
      state.snowSensor.selectedOne = null;
      state.optionalConstant.selectedOne = null;
      state.heatingSchedule.selectedOne = null;
      state.windFactor.selectedOne = null;
      state.ats.selectedOne = null;
      state.shutOff.selectedOne = null;
      state.fanOnly.selectedOne = null;
    },
    handleSelectedOneBySwitch: (state, action) => {
      state[action.payload.controller].selectedOne = action.payload.selectedOne;
    },

    handleSelectAllBySwitch: (state, action) => {

      state[action.payload.controller].isAllSelected = action.payload.status;
    },

    handleLocationSelectBySwitch: (state, action) => {
      state[action.payload.controller].isLocationSelected = action.payload.arr;
    },

    handleSpecificLocationSelectBySwitch: (state, action) => {
      state[action.payload.controller].isSpecificLocationSelected =
        action.payload.arr;
    },

    handleMachineSelectBySwitch: (state, action) => {
      state[action.payload.controller].isMachineSelected = action.payload.arr;
    },

    handleMachineSelectAllBySwitch: (state, action) => {
      console.log("MachineSelect","handleMachineSelectAllBySwitch",action.payload)
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.machineIdx] = true;
    },


    handleAddLocationsBySwitch: (state, action) => {
      state[action.payload.controller].selectedLocations = action.payload.arr;
    },

    handleAddSpecificLocationsBySwitch: (state, action) => {
      state[action.payload.controller].selectedSpecificLocations =
        action.payload.arr;
    },

    handleAddMachinesBySwitch: (state, action) => {
      state[action.payload.controller].selectedMachines = action.payload.arr;
    },
    handleMachineSelectAltBySwitch: (state, action) => {
      console.log("MachineSelect","handleMachineSelectAltBySwitch",action.payload)
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.machineIdx] = true;
    },
    handleMachineSelectWithSpecLocationAltBySwitch: (state, action) => {
      console.log("MachineSelect","handleMachineSelectWithSpecLocationAltBySwitch",action.payload)
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.specLocationIdx][action.payload.machineIdx] = true;
    },

    handleResetAllSelectBySwitch: (state, action) => {
      return { ...initialState };
    },

    handleDisplaySelectBoxBySwitch: (state, action) => {
      state[action.payload.controller].displaySelectBox =
        !state.displaySelectBox;
    },

    handleDisplaySelectBoxWithActionBySwitch: (state, action) => {
      state.displaySelectBox = action.payload;
    },

    handleApplyWithTemp: (state, action) => {

      state[action.payload.controller].isApplied =
        !state[action.payload.controller].isApplied;

      state[action.payload.controller].inputTemp = action.payload.temp;
    },
    handleSetScheduleList: (state, action) => {
      state.heatingSchedule.scheduleList[action.payload.index] = {
        start: action.payload.start,
        end: action.payload.end,
        inputTemp: action.payload.inputTemp,
        isF: action.payload.isF,
      };

      state.heatingSchedule.scheduleList[action.payload.index + 1] = {
        start: { date: null, time: null },
        end: { date: null, time: null },
        inputTemp: null,
        isF: null,
      };
    },
  },
});

export default masterControlSelectBySwitchSlice;
export const selectMCBySwitch = (state) => state.masterControlSelectBySwitch;
export const {
  handleSelectAllBySwitch,
  handleSelectedOneBySwitch,
  handleLocationSelectBySwitch,
  handleSpecificLocationSelectBySwitch,
  handleMachineSelectBySwitch,
  handleAddLocationsBySwitch,
  handleAddSpecificLocationsBySwitch,
  handleAddMachinesBySwitch,
  handleMachineSelectAllBySwitch,
  handleResetAllSelectBySwitch,
  handleDisplaySelectBoxBySwitch,
  handleDisplaySelectBoxWithActionBySwitch,
  handleMachineSelectAltBySwitch,
  handleMachineSelectWithSpecLocationAltBySwitch,

  handleApplyWithTemp,
  handleSetSchedule,
  handleResetSelectedOne,
} = masterControlSelectBySwitchSlice.actions;
